module.exports = __webpack_public_path__ + "img/logo.c815cae5.png";